const EmblaCarouselModule = require('embla-carousel');
const emblaCarousel = EmblaCarouselModule.default;
const addPrevNextBtnsClickHandlers = require('./EmblaCarouselArrowButtons').addPrevNextBtnsClickHandlers;
// uncomment below to use dot buttons in embla. Foundational code is not currently in use and is commented out below.
// const addDotBtnsAndClickHandlers = require('EmblaCarouselDotButtons').addDotBtnsAndClickHandlers;

const emblaNode = document.getElementById('visualNav');
const viewportNode = emblaNode.querySelector('.embla__viewport');

const BREAKPOINTS = {
  med: 768,
  large: 1024
};

const OPTIONS = {
  align: 'center',
  containScroll: 'trimSnaps',
  active: true,
  dragFree: true,
  slidesToScroll: 3,
  breakpoints: {
    [`(min-width: ${BREAKPOINTS.med}px)`]: {
      slidesToScroll: 5
    },
    [`(min-width: ${BREAKPOINTS.large}px)`]: {
      slidesToScroll: 5
    }
  }
};

const emblaApi = emblaCarousel(viewportNode, OPTIONS);

const updateCarouselActiveState = () => {
  if (!emblaApi) return false;

  const canScroll = emblaApi.scrollSnapList().length > 1;
  const currentOptions = emblaApi.internalEngine().options;

  if (currentOptions.active !== canScroll) {
    const newOptions = Object.assign({}, currentOptions, { active: canScroll });
    emblaApi.reInit(newOptions);
  }
  return null;
};

if (emblaApi) {
  emblaApi.on('init', updateCarouselActiveState);
  emblaApi.on('reInit', updateCarouselActiveState);
  emblaApi.on('settle', updateCarouselActiveState);
  emblaApi.on('select', updateCarouselActiveState);

  let resizeTimeout;

  const onResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const currentOptions = emblaApi.internalEngine().options;
      const updatedOptions = Object.assign({}, currentOptions, { active: true });
      emblaApi.reInit(updatedOptions);
      updateCarouselActiveState();
    }, 150);

    const cleanup = () => {
      window.removeEventListener('resize', onResize);
    };

    window.addEventListener('resize', onResize);
    emblaApi.on('destroy', cleanup);
  };
}

const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
const nextBtnNode = emblaNode.querySelector('.embla__button--next');
const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApi, prevBtnNode, nextBtnNode);
emblaApi.on('destroy', removePrevNextBtnsClickHandlers);

// dot navigation nodes foundational code
// const dotsNode = emblaNode.querySelector('.embla__dots');
// const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(emblaApi, dotsNode);
// emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
